import { render } from "./SaveContactNumberModal.vue?vue&type=template&id=2ae0b964&scoped=true"
import script from "./SaveContactNumberModal.vue?vue&type=script&lang=js"
export * from "./SaveContactNumberModal.vue?vue&type=script&lang=js"

import "./SaveContactNumberModal.vue?vue&type=style&index=0&id=2ae0b964&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae0b964"]])

export default __exports__